// Turn <input type='currency' /> elements into an actual currency input.
// https://stackoverflow.com/a/54534797/139299

export function currencyToNumber(s) {
  return Number(String(s).replace(/[^0-9.-]+/g, ''));
}

export function numberToCurrency(value) {
  const currency = 'GBP';
  const options = {
    maximumFractionDigits : 2,
    currency              : currency,
    style                 : 'currency',
    currencyDisplay       : 'symbol'
  };
  return (value || value === 0)
    ? currencyToNumber(value).toLocaleString(undefined, options)
    : '£0.00';
}

$(function() {
  function elementsAsCurrency(elements) {
    $.each(elements, function() {
      const value = $(this).val();
      $(this).val(numberToCurrency(value));
    });
  }

  function onFocus(e) {
    const value = e.target.value;
    e.target.value = value ? currencyToNumber(value) : '';
  }

  function onBlur(e) {
    const value = e.target.value;
    e.target.value = numberToCurrency(value);
  }

  // Apply the events to page loaded elements.
  const currencyElements = $('input[type="currency"]');
  elementsAsCurrency(currencyElements);
  currencyElements.on('focus', onFocus);
  currencyElements.on('blur', onBlur);

  // Apply the events to cocoon generated elements.
  $(document).on('cocoon:after-insert', '.cocoon-container:has(input[type="currency"])', function(e, insertedItem) {
    const currencyElements = $(insertedItem).find('input[type="currency"]');
    elementsAsCurrency(currencyElements);
    currencyElements.on('focus', onFocus);
    currencyElements.on('blur', onBlur);
  });
});
